import { jsx } from "react/jsx-runtime";
import { Component, useEntityList, HasMany } from "@contember/binding";
import { RepeaterInner } from "./RepeaterInner.js";
const Repeater = Component(
  (props) => {
    const entityList = useEntityList(props);
    return /* @__PURE__ */ jsx(RepeaterInner, { ...props, accessor: entityList });
  },
  (props, environment) => /* @__PURE__ */ jsx(HasMany, { ...props, initialEntityCount: props.initialEntityCount ?? 1, children: RepeaterInner.staticRender(props, environment) }),
  "Repeater"
);
export {
  Repeater
};
//# sourceMappingURL=Repeater.js.map
